//import Cockpitsapi from '@/services/api/cockpits'
import Portfolioapi from '@/services/api/portfolio'


const portfolio = {
	state:{
		activePortfolio:{},
		isactive: false,
		portfolio:[],
		boards:[]
		//portfoliostore:{"ok":123}
	},
	mutations:{
		SET_PORTFOLIO(state,portfolio){
			state.portfolio = Object.assign({}, state.portfolio , portfolio)
		},
		SET_BOARDS(state,boards){
			state.boards = Object.assign({}, state.boards , boards)
		},
	},
	actions:{
		getportfoliobyID({commit},payload){

			var thisPromise = Portfolioapi.getOne({ pid:payload.pid, token:payload.token, orgkey:payload.orgkey, parameters:payload.parameters })


			return new Promise((resolve, reject) =>{

				thisPromise.then( response =>{
					if(response.data.ok){
						commit('SET_PORTFOLIO', response.data.portfolio);
						resolve(response)
					}
				}) .catch(error => {console.log(error); reject(error)})
				.finally( () => {

				})

			})
			
		},

		getboards({commit},payload){
			let thispromise = Portfolioapi.getboards( { excludes:payload.excludes, token:payload.token, orgkey:payload.orgkey } )

			return new Promise((resolve, reject) =>{

				thispromise.then( response =>{
					if(response.data.ok){
						commit('SET_BOARDS', response.data.boards);
						resolve(response)
					}
				}) .catch(error => {console.log(error); reject(error)})
				.finally( () => {

				})

			})


		}
	},
	getters:{		
		portfolio: state => state.portfolio,
		boards: state => state.boards
	},
	modules: {

	}
}


export default portfolio